module.exports = __webpack_public_path__ + "static/media/compressor@112x112.d93f8447.png";